/* ------------------------------------------------------------------
   Patch OKKO al tema Maximize.
   Un aggiornamento del tema cancella questo file: riapplicare da
   _risorse/shopify/b2c/tema-patch/ e ricontrollare theme.liquid.
   ------------------------------------------------------------------ */

/* Carrello disallineato tornando indietro.
   Chi aggiunge un prodotto dal popup di upsell e poi torna indietro
   (gesture del telefono o tasto del browser) vede il carrello di prima,
   senza il prodotto appena aggiunto, finche' non ricarica a mano.

   Le pagine del negozio non hanno header Cache-Control, quindi il browser
   puo' ripristinarle dal back/forward cache senza rieseguire il JS, oppure
   riproporre l'HTML dalla cache HTTP. In entrambi i casi il DOM mostra uno
   stato del carrello piu' vecchio di quello vero sul server.

   Qui si confronta il carrello reale con quello con cui la pagina e' stata
   COSTRUITA (window.__okkoCarrelloRender, scritto da theme.liquid al render):
   se non coincidono, si ricarica. Il confronto col valore di render, e non
   con una lettura fatta al momento, e' quello che rende la correzione valida
   sia per il bfcache sia per l'HTML servito dalla cache. */
(function () {
  "use strict";

  function statoAtteso() {
    var r = window.__okkoCarrelloRender;
    return r ? r.n + "|" + r.tot : null;
  }

  function statoReale() {
    return fetch("/cart.js", { cache: "no-store", headers: { Accept: "application/json" } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (c) { return c ? c.item_count + "|" + c.total_price : null; })
      .catch(function () { return null; });
  }

  window.addEventListener("pageshow", function (e) {
    var nav = performance.getEntriesByType("navigation")[0];
    var tornatoIndietro = e.persisted || (nav && nav.type === "back_forward");
    if (!tornatoIndietro) return;

    var atteso = statoAtteso();
    if (atteso === null) return;          // marcatore assente: non si tocca niente

    statoReale().then(function (reale) {
      if (reale !== null && reale !== atteso) {
        window.location.reload();
      }
    });
  });
})();
